import RequestedFeature from '@carvana/merch-contracts/RequestedFeature';
import SortOption from '~/constants/common/SortOption';
import type { InventoryRequestAnalytics } from '~/services/common/contracts/InventoryRequest';

const RECENT_INVENTORY_PAGE_SIZE = 12;

export function buildRecentInventoryRequest({
  analyticsData,
  browserCookieId,
  vehicleIds,
  zip
}: {
  analyticsData: InventoryRequestAnalytics;
  browserCookieId: string;
  vehicleIds: Array<number>;
  zip: string;
}) {
  return {
    analyticsData,
    browserCookieId,
    filters: { vehicleIds },
    pagination: { page: 1, pageSize: RECENT_INVENTORY_PAGE_SIZE },
    requestedFeatures: [RequestedFeature.ExcludeFacetData],
    sortBy: SortOption.MostPopular,
    zip5: zip
  };
}

export function sortByRecentOrder<T extends { vehicleId: number }>(
  vehicles: Array<T>,
  recentVehicleIds: Array<number>
): Array<T> {
  return [...vehicles].sort(
    (a, b) =>
      recentVehicleIds.indexOf(a.vehicleId) -
      recentVehicleIds.indexOf(b.vehicleId)
  );
}
